import { GetAccommodationResponse } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { createTripMutation } from './createTripCrudResource'

export interface UpdateAccommodationPayload {
    name?: string
    checkInDate?: string
    checkOutDate?: string
    guestUserIds?: number[]
    notes?: string | null
    links?: string[]
    location?: {
        fullText: string
        primaryText?: string | null
        secondaryText?: string | null
        googlePlaceId?: string | null
        googleTypes?: string[]
    } | null
}

export const useUpdateAccommodation = createTripMutation<
    GetAccommodationResponse,
    { tripId: string; accommodationId: number; accommodationData: UpdateAccommodationPayload }
>({
    mutationFn: async ({ tripId, accommodationId, accommodationData }) => {
        const response = await api.patch<GetAccommodationResponse>(`/trips/${tripId}/accommodations/${accommodationId}`, accommodationData)
        return response.data
    },
    invalidate: ({ tripId }) => [queryKeys.accommodations(tripId)],
})
